/**
 *
 * StyledEmailPreview
 *
 */

import styled from "styled-components";

const StyledEmailPreview = styled.div`
  min-height: 300px;
  width: 95%;
  font-size: 12px;
  color: #333;
  border: 1px solid #999;
  padding: 10px;
  ${(props) =>
    props.callLocation === "search"
      ? `margin: 3px 2.5% 3px 2.5%`
      : `> * {
    margin: 3px 2.5% 3px 2.5%;
  }`}
`;

export default StyledEmailPreview;
